var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage mathMaster"
  }, [_c('div', {
    class: {
      withoutAnswer: _vm.withoutAnswer
    },
    attrs: {
      "id": "squares"
    }
  }, _vm._l(_vm.result.numbers, function (number, index) {
    return _c('square', {
      key: ("number" + index),
      class: [{
        answer: index === 2
      }],
      attrs: {
        "track-by": "$index",
        "number": number === 0 ? 'zero' : number
      }
    });
  }), 1), _c('div', {
    attrs: {
      "id": "expression"
    }
  }, _vm._l(_vm.result.steps, function (step, index) {
    return _c('blinking-cursor-text', {
      key: ("step" + index),
      class: ['blink-text', {
        answer: index === 4
      }],
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    });
  }), 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.chooseResult,
      expression: "chooseResult"
    }],
    style: {
      marginTop: _vm.usingExternalKeyboard && _vm.usingMobileChrome ? '50px' : '140px'
    },
    attrs: {
      "id": "results"
    }
  }, _vm._l(_vm.currentRound.results, function (result, index) {
    return _c('div', {
      key: ("result" + index),
      staticClass: "result",
      attrs: {
        "track-by": "$index",
        "id": ("res" + index)
      },
      on: {
        "click": function ($event) {
          return _vm.isCorrectAnswer(result);
        }
      }
    }, [_c('square', {
      attrs: {
        "number": result.number === 0 ? 'zero' : result.number
      }
    }), _c('p', {
      domProps: {
        "textContent": _vm._s(result.text)
      }
    })], 1);
  }), 0), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }